import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/toPromise';

import { Contact } from './contact.interface';

@Injectable()
export class ContactService {
  private URL = '//mailer.axented.com';
  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }
  constructor(private _http: Http) { }

  getInTouch(contact: Contact) {
    return this._http
    .post(`${this.URL}/submit`, contact)
    .toPromise()
    .then(response => {
      return response;
    })
    .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.service.ts